import { AssistantReservationTimeState } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { TagVariant } from '@optimus-web/core';

type ReservationTimeStateMap = Record<
    AssistantReservationTimeState,
    {
        textKey: Mews.TextKey;
        tagVariant: TagVariant;
    }
>;
export const reservationTimeSateTextKeyVariant: ReservationTimeStateMap = {
    [AssistantReservationTimeState.Past]: { textKey: TextKey.ReservationTimeStatePast, tagVariant: 'basicSubtle' },
    [AssistantReservationTimeState.CheckOutMissed]: {
        textKey: TextKey.ReservationTimeStateCheckInMissed,
        tagVariant: 'tangerine',
    },
    [AssistantReservationTimeState.ToBeCheckedOut]: {
        textKey: TextKey.ReservationTimeStateToBeCheckedOut,
        tagVariant: 'denim',
    },
    [AssistantReservationTimeState.CheckedIn]: { textKey: TextKey.CheckedIn, tagVariant: 'basicBold' },
    [AssistantReservationTimeState.CheckInMissed]: {
        textKey: TextKey.ReservationTimeStateCheckInMissed,
        tagVariant: 'tangerine',
    },
    [AssistantReservationTimeState.ToBeCheckedIn]: {
        textKey: TextKey.ReservationTimeStateToBeCheckedIn,
        tagVariant: 'info',
    },
    [AssistantReservationTimeState.Future]: { textKey: TextKey.ReservationTimeStateFuture, tagVariant: 'basicSubtle' },
    [AssistantReservationTimeState.ToBeConfirmed]: { textKey: TextKey.ToBeConfirmed, tagVariant: 'basicSubtle' },
    [AssistantReservationTimeState.ConfirmationMissed]: {
        textKey: TextKey.ConfirmationMissed,
        tagVariant: 'tangerine',
    },
};
